import { render, staticRenderFns } from "./CenterViewEventManagement_Ap.vue?vue&type=template&id=70f1b38a&scoped=true"
import script from "./CenterViewEventManagement_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventManagement_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventManagement_Ap.vue?vue&type=style&index=0&id=70f1b38a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f1b38a",
  null
  
)

export default component.exports